import { IconButton, Tooltip } from "@mui/material";
import { Moon, Sun } from "./icons";
import { useSettings } from "../providers/SettingsProvider";
import { useThemeMode } from "../providers/AppThemeProvider";

export function ThemeSelector() {
    const settings = useSettings();
    const { mode, toggle } = useThemeMode();

    if (!settings.features?.themeSelection) return null;

    return (
        <Tooltip title={mode === "dark" ? "Switch to light mode" : "Switch to dark mode"} arrow>
            <IconButton id="btn-theme-selector" onClick={toggle}>
                {mode === "dark" ? <Sun size="small" /> : <Moon size="small" />}
            </IconButton>
        </Tooltip>
    );
}
